import React from 'react'
import { withCheckout } from './CheckoutContext'
import Address from './Address'

const AddressStepSummary = ({ order }) => {
  const { shipAddress } = order

  return (
    <Address address={shipAddress} />
  )
}

export default withCheckout(AddressStepSummary)
